import React from 'react';
import $ from 'jquery';
import L from 'leaflet/dist/leaflet';

import QBMap from './maps/qbMap';

class MapSection extends React.Component {
  constructor() {
    super();

    this.state = {
      markers: []
    };

    this.handleMarkerClick = this.handleMarkerClick.bind(this);
    this.handleMarkerClose = this.handleMarkerClose.bind(this);
  }

  componentDidMount() {
    this.ajaxMarkers();
  }

  initMap() {
    const map = L.map('map', {
      center: this.center(),
      scrollWheelZoom: false,
      zoom: this.zoom(),
      zoomControl: false,
      maxZoom: QBMap.MAX_ZOOM,
      minZoom: QBMap.MIN_ZOOM
    });

    L.control.zoom({
      position: 'bottomright'
    }).addTo(map);

    L.tileLayer('https://api.mapbox.com/styles/v1/qpb/clgvzp8ta007h01r0hxj1f6u4/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicXBiIiwiYSI6ImNsZ3A3a3owYTB3dmYzZW9lZGE3M2ZjbWYifQ.afNCxkpPYhQfjMseXYjpiA', {
      tileSize: 512,
      zoomOffset: -1,
      attribution: '&copy; <a href="https://www.mapbox.com/contribute/">Mapbox</a> &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    const qbIcon = L.icon({
      iconUrl: 'https://www.quirinprivatbank.de/system/images/294/original/marker.png',
      iconSize: [34, 34],
      iconAnchor: [17, 34]
    });

    this.state.markers.forEach((marker) => {
      const markerPosition = marker.position;

      L.marker([markerPosition.lat, markerPosition.lng], { icon: qbIcon })
        .addTo(map)
        .bindPopup(marker.infoContent, {
          offset: L.point(0, -17)
        })
        .on('mouseover', function openPopup() {
          this.openPopup();
        });
    });
  }

  ajaxMarkers() {
    $.ajax({
      url: `/api/maps/branches/${this.props.apiEndpoint}.json`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          this.setState({ markers: data.branches }, this.initMap);
        }
      },
      error: (xhr, status, err) => console.error(xhr, status, err.toString())
    });
  }

  markersShowInfo(markers, targetMarker, showInfo) {
    return markers.map((marker) => {
      // turn false to close already open markers
      marker.showInfo = false;

      if (marker.key === targetMarker.key) {
        marker.showInfo = showInfo;
      }

      return marker;
    });
  }

  handleMarkerClick(targetMarker) {
    this.setState({
      markers: this.markersShowInfo(this.state.markers, targetMarker, true)
    });
  }

  handleMarkerClose(targetMarker) {
    this.setState({
      markers: this.markersShowInfo(this.state.markers, targetMarker, false)
    });
  }

  center() {
    if (this.state.markers.length === 1) {
      const markerPosition = this.state.markers[0].position;

      return [markerPosition.lat, markerPosition.lng];
    }

    return QBMap.GERMANY_CENTER;
  }

  zoom() {
    if (this.state.markers.length === 1) {
      return QBMap.CITY_ZOOM;
    }

    return QBMap.DEFAULT_ZOOM;
  }

  render() {
    return <div id="map"></div>;
  }
}

MapSection.propTypes = {
  apiEndpoint: React.PropTypes.string
};

export default MapSection;



// WEBPACK FOOTER //
// ./components/mapSection.js